<template>
  <div class="txt-black">
    <div class="rounded-lg p-3 shadow-2xl bg-white mb-2" v-loading="loading">
      <!-- Title bar -->
      <div class="flex">
        <div class="fs-20 fw-500 ml-1">Tài liệu tham khảo</div>
        <div class="ml-auto flex"></div>
      </div>
      <!-- Form link -->
      <div class="my-3" v-if="formLink">
        <div class="flex justify-between items-center mb-2">
          <div class="w-20">Tên link</div>
          <el-input v-model="formLink.name"></el-input>
        </div>
        <div class="flex justify-between items-center mb-2">
          <div class="w-20">Đường dẫn</div>
          <el-input v-model="formLink.url"></el-input>
        </div>
        <div class="flex justify-end space-x-3">
          <el-button @click="closeAddLink">Hủy</el-button>
          <el-button type="primary" @click="submitLink">Lưu link</el-button>
        </div>
      </div>
      <div></div>
      <!-- List files -->
      <div class="mt-2" v-if="patientVisitFiles">
        <div v-for="(file, index) in patientVisitFiles" :key="index + 'file'">
          <div class="h-full rounded-xl pb-2 pt-2">
            <div class="text-base row">
              <div class="col-10">
                <div class="flex">
                  <!-- File icon -->
                  <span v-if="file.type === 1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_24814_125783)">
                        <path
                          d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                          fill="#0263D1"
                        />
                        <path
                          opacity="0.302"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                          fill="white"
                        />
                        <path
                          d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                          fill="white"
                        />
                        <path d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z" fill="white" />
                        <path
                          d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                          fill="white"
                        />
                        <path
                          d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_24814_125783">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span v-if="file.type === 2">
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66672 11.9601L5.48672 13.1068C5.1773 13.4162 4.75764 13.5901 4.32005 13.5901C3.88247 13.5901 3.46281 13.4162 3.15339 13.1068C2.84397 12.7974 2.67014 12.3777 2.67014 11.9401C2.67014 11.5026 2.84397 11.0829 3.15339 10.7735L6.18005 7.74014C6.47713 7.4421 6.8774 7.26966 7.29806 7.25849C7.71873 7.24732 8.12758 7.39828 8.44005 7.68014L8.52005 7.74681C8.64647 7.87057 8.81688 7.93905 8.99379 7.93718C9.1707 7.9353 9.33962 7.86323 9.46339 7.73681C9.58716 7.61039 9.65563 7.43998 9.65376 7.26307C9.65188 7.08616 9.57981 6.91724 9.45339 6.79347C9.41576 6.74482 9.37571 6.6981 9.33339 6.65347C8.76429 6.15835 8.02828 5.89804 7.27443 5.92527C6.52059 5.9525 5.80528 6.26524 5.27339 6.80014L2.20672 9.83347C1.68562 10.4007 1.4038 11.1473 1.4201 11.9173C1.43641 12.6874 1.74957 13.4214 2.29421 13.966C2.83884 14.5106 3.57283 14.8238 4.34289 14.8401C5.11294 14.8564 5.85952 14.5746 6.42672 14.0535L7.58005 12.9268C7.69393 12.8026 7.75653 12.6398 7.75526 12.4713C7.75399 12.3028 7.68894 12.141 7.57319 12.0185C7.45745 11.896 7.29961 11.8219 7.13143 11.811C6.96325 11.8002 6.79721 11.8535 6.66672 11.9601ZM13.7934 2.46681C13.2326 1.90948 12.474 1.59666 11.6834 1.59666C10.8927 1.59666 10.1342 1.90948 9.57339 2.46681L8.42005 3.59347C8.30618 3.71771 8.24358 3.88046 8.24485 4.04898C8.24612 4.21751 8.31117 4.3793 8.42691 4.5018C8.54265 4.6243 8.7005 4.69841 8.86868 4.70924C9.03686 4.72006 9.2029 4.66679 9.33339 4.56014L10.4867 3.41347C10.7961 3.10405 11.2158 2.93022 11.6534 2.93022C12.091 2.93022 12.5106 3.10405 12.8201 3.41347C13.1295 3.72289 13.3033 4.14255 13.3033 4.58014C13.3033 5.01772 13.1295 5.43739 12.8201 5.74681L9.79339 8.78014C9.49631 9.07818 9.09604 9.25062 8.67538 9.26179C8.25472 9.27296 7.84586 9.122 7.53339 8.84014L7.45339 8.77347C7.32697 8.6497 7.15656 8.58123 6.97965 8.5831C6.80274 8.58498 6.63382 8.65705 6.51005 8.78347C6.38629 8.90989 6.31781 9.0803 6.31968 9.25721C6.32156 9.43412 6.39363 9.60304 6.52005 9.72681C6.56848 9.77633 6.61967 9.82307 6.67339 9.86681C7.24317 10.3604 7.97887 10.6198 8.73225 10.5926C9.48564 10.5653 10.2007 10.2536 10.7334 9.72014L13.7667 6.68681C14.3276 6.12952 14.6452 5.37296 14.6502 4.5823C14.6552 3.79165 14.3472 3.03113 13.7934 2.46681Z"
                        fill="#6E7883"
                      />
                    </svg>
                  </span>
                  <div
                    @click="openFile(file)"
                    class="ml-2 name-file-class underline text-primary cursor-pointer"
                  >
                    <span>{{ file.name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ml-8 text-sm">
              <span>{{ file.created_by && file.created_by.name }}</span>
              <span class="ml-3">{{ formatDMY(file.created_at) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Upload file -->
    <input
      type="file"
      @change="onSelectedFile($event)"
      class="d-none"
      ref="inputFileConsulationAppt"
      multiple
    />
    <div
      class="modal fade"
      id="modalUploadConsulationAppt"
      tabindex="-1"
      aria-labelledby="modalUploadTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content shadow-lg">
          <div class="modal-header border-0 bg-white mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">Chọn tệp đính kèm</h5>
            <img
              @click="modalUploadConsulationAppt(false)"
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="upload-btn mb-3" @click="uploadDocs">
              <img class="mr-1" src="../../../public/assets/images/icon/u_upload.svg" />
              <span class="fs-14 txt-pri">Chọn file</span>
            </div>
            <div class="mb-3" v-for="(doc, i) in nameFiles" :key="i + 'slt_file'">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <el-input v-model="doc.description" class="fs-14 fw-600 mb-0 max-line-1 w-265px" />
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer"
                  @click="deleteSltDoct(i)"
                >
                  <path
                    d="M6.00012 18.4998L17.9999 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.9999 18.4998L6.00012 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="onUpload"
              :disabled="!selected_docs || !selected_docs.length"
            >Tải lên</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Message aleart -->
    <el-dialog v-model="dialogMessageVisible" title="Tips" width="30%">
      <span>This is a message</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import uploadPatientFiles from '../../utils/uploadPatientFiles'
import { mapState } from 'vuex'

export default {
  name: 'UploadFilesTemp',
  props: {
    patientVisitFiles: {
      type: Array,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    statusPatientVisit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      clinic: null,
      loading: false,
      dialogMessageVisible: false,
      dialogVisible: false,
      consultation: null,
      startTime: null,
      indications: [],
      prescriptions: [],
      uploadPatientFiles,
      selected_docs: [],
      nameFiles: [],
      links: [],
      files: [],
      formLink: null,
      check: null
    }
  },
  computed: {
    ...mapState({
      personHR: state => state.personHR
    })
  },
  watch: {
    $refresh () {
      this.$emit('refresh')
      this.selected_docs = []
      this.nameFiles = []
    }
  },
  methods: {
    showMessageAleartDeletefile () {
      this.dialogMessageVisible = true
    },
    openFile (file) {
      console.log(file)
      if (file.type === 1) {
        this.downloadFile(file.file_name)
      } else {
        this.openLink(file.url)
      }
    },
    async deleteFile (idFile) {
      this.$confirm(
        this.$t(`Bạn chắc chắn muốn xóa file này?`),
        this.$t('Cảnh báo')
      )
        .then(async _ => {
          await this.$rf
            .getRequest('AuthRequest')
            .deletePatientFile(idFile)
            .then(r => {
              this.$emit('refresh')
            })
            .catch(e => {
              window.$toast.open({
                message: 'Lỗi xóa file',
                type: 'danger'
              })
              console.error(e)
            })
        })
        .catch(_ => {})
    },
    deleteSltDoct (i) {
      this.selected_docs.splice(i, 1)
      this.nameFiles.splice(i, 1)
    },
    async onSubmitFiles (docs) {
      return uploadPatientFiles.fileUploadHanlder(
        this.id,
        docs,
        1,
        null,
        this.nameFiles
      )
    },
    async onUpload () {
      if (!this.selected_docs || !this.selected_docs.length) {
        alert(this.$t('multidisciplinary_board.lbl_select_file_sh'))
        return
      }
      await this.onSubmitFiles(this.selected_docs)
      this.$refs.inputFileConsulationAppt.value = null
      this.modalUploadConsulationAppt(false)
    },
    modalUploadConsulationAppt (show) {
      window.$('#modalUploadConsulationAppt').modal(show ? 'show' : 'hide')
    },
    uploadDocs () {
      this.$refs.inputFileConsulationAppt.click()
      this.$refs.inputFileConsulationAppt.value = null
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.nameFiles.push({
            description: files[i].name
          })
          this.selected_docs.push(files[i])
          console.log('this.nameFiles[i]', this.nameFiles[i])
        }
      }
    },
    async downloadFile (name) {
      if (!name) return

      if (name.includes('https://')) {
        window.open(name)
        return
      }
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf
        .getRequest('AuthRequest')
        .getLinkDownloadAwsRc(params, header, false)
        .then(r => {
          if (r?.data?.data) window.open(r.data.data)
        })
        .catch(e => {
          self.$toast.open({
            message: this.$t('circle_feature.lbl_err_down_msg'),
            type: 'warning'
          })
          console.error(e)
        })
    },
    formatDMY (date) {
      return date && window.moment(date).format('HH:mm DD-MM-YYYY')
    },
    addLink () {
      this.formLink = {
        name: '',
        url: '',
        type: 2
      }
    },
    openLink (link) {
      console.log(link)
      link && window.open(link)
    },
    closeAddLink () {
      this.formLink = null
    },
    submitLink () {
      if (!this.formLink.name || !this.formLink.url) {
        alert('Vui lòng nhập đủ thông tin')
        return
      }
      this.createLink(this.formLink)
    },
    async createLink (options) {
      const params = {
        ...options,
        patient_visit_id: this.id
      }
      await this.$rf
        .getRequest('AuthRequest')
        .uploadPatientFiles(params)
        .then(r => {
          this.closeAddLink()
          this.$emit('refresh')
          return r.data
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    viewDetail (obj) {
      this.$refs.ModalViewHR.openDialog(obj.id)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .required:after {
    content: ' *';
    color: red;
  }

  .upload-btn {
    width: 100%;
    border: 1px dashed #20419b;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    border-radius: 9px;
    cursor: pointer;
  }

  .upload-btn2 {
    padding: 18px 0px 18px 0px;
  }

  .w-265px {
    width: 100%;
    max-width: 265px;
  }
}

@media only screen and (max-width: 600px) {
  .name-file-class {
    white-space: nowrap;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
